import React, { useState } from 'react';
import './TabStyles.css';
import TiersSection from "../../../../components/sinistreSection/tiersSection";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    annulerStyle: {
        width: '83px',
        height: '36px',
        borderRadius: '5px',
        border: '0.61px solid rgba(226, 217, 239, 1)',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '20px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
        backgroundColor: 'rgba(229, 234, 238, 1)',
        color: 'rgba(128, 128, 143, 1)',
        marginRight: '20px',
    },
    validerStyle: {
        width: '83px',
        height: '36px',
        borderRadius: '5px',
        border: '0.61px solid rgba(226, 217, 239, 1)',
        fontFamily: 'Poppins, sans-serif',
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '20px',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease',
        backgroundColor: 'rgba(86, 157, 210, 1)',
        color: 'rgba(255, 255, 255, 1)',
        marginRight: '40px',
    },
}));

const PartiesTab = ({ listOfParties, handlePrevious, handleNext, formData, handleFormChange }) => {
    const classes = useStyles();
    const [parties, setParties] = useState([]);
    console.log('formdata', formData);
    const handleAddParty = () => {
        setParties([...parties, { nom: '', role: '', type: '', contact: '', statut: '' }]);
    };

    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        const updatedParties = parties.map((party, i) => (
            i === index ? { ...party, [name]: value } : party
        ));
        setParties(updatedParties);
    };

    return (
        <div className="container">
            {listOfParties.length > 0 ? (
                <>
                    {/* <div style={{ display: 'flex', alignItems: 'center' }}>
                        <button
                            className="add-task-button"
                            onClick={handleAddParty}
                            style={{
                                width: '110px',
                                height: '34px',
                                borderRadius: '6px',
                                background: '#D5E5F2',
                                border: 0,
                                fontFamily: 'Poppins',
                                fontSize: '15px',
                                fontWeight: 600,
                                lineHeight: '18px',
                                color: '#4969B4',
                                marginBottom: '30px',
                                marginLeft: 'auto',
                            }}
                        >
                            Ajouter +
                        </button>
                    </div> */}

                    <TiersSection listOfParties={listOfParties} />

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                        <button className={classes.annulerStyle} onClick={handlePrevious}>Précédent</button>
                        <button className={classes.validerStyle} onClick={handleNext}>Suivant</button>
                    </div>
                </>
            ) : (
                <>
                    <p style={{ textAlign: 'center', marginTop: '20px' }}>
                        Il faut choisir un numéro de sinistre pour afficher les parties reliées.
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                        <button className={classes.annulerStyle} onClick={handlePrevious}>Précédent</button>
                        <button className={classes.validerStyle} onClick={handleNext}>Suivant</button>
                    </div>
                </>
            )}
        </div>
    );
};

export default PartiesTab;
